import { useMemo } from 'react';
import { useAdminPermissions } from '../admin';
import { useAiAssistantPermissions } from '../ai-assistant';
import { useChannelsPermissions } from '../channels';
import { useChatPermissions } from '../chat';
import { useCommentPermissions } from '../comment';
import { useCommunitiesPermissions } from '../communities';
import { useContentObjectPermissions } from '../content-object';
import { useEhrPermissions } from '../ehr';
import { useEventPermissions } from '../event';
import { useGivingsPermissions } from '../givings';
import { useOrganizationsPermissions } from '../organizations';
import { useProgramsPermissions } from '../programs';
import { useSettingsPermissions } from '../settings';
import { useVideoPermissions } from '../videos';

export const usePermissions = () => {
  const aiAssistantPermissions = useAiAssistantPermissions();
  const eventPermissions = useEventPermissions();
  const organizationsPermissions = useOrganizationsPermissions();
  const communitiesPermissions = useCommunitiesPermissions();
  const givingsPermissions = useGivingsPermissions();
  const programsPermissions = useProgramsPermissions();
  const channelsPermissions = useChannelsPermissions();
  const chatPermissions = useChatPermissions();
  const contentObjectPermissions = useContentObjectPermissions();
  const adminPermissions = useAdminPermissions();
  const ehrPermissions = useEhrPermissions();
  const commentPermissions = useCommentPermissions();
  const settingsPermissions = useSettingsPermissions();
  const videoPermissions = useVideoPermissions();

  return useMemo(
    () => ({
      ...aiAssistantPermissions,
      ...organizationsPermissions,
      ...communitiesPermissions,
      ...givingsPermissions,
      ...programsPermissions,
      ...eventPermissions,
      ...channelsPermissions,
      ...chatPermissions,
      ...contentObjectPermissions,
      ...adminPermissions,
      ...ehrPermissions,
      ...commentPermissions,
      ...settingsPermissions,
      ...videoPermissions,
    }),
    [
      aiAssistantPermissions,
      organizationsPermissions,
      communitiesPermissions,
      givingsPermissions,
      programsPermissions,
      eventPermissions,
      channelsPermissions,
      chatPermissions,
      contentObjectPermissions,
      adminPermissions,
      ehrPermissions,
      commentPermissions,
      settingsPermissions,
      videoPermissions,
    ],
  );
};
